import { premiumBuildingsPrices } from "@/config/constants";
import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { type TileIndex } from "@/types/tile";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";
class AdvancedIronMineBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.ADVANCED_IRON_MINE;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];

	public get suppliesTileIndexes(): Set<TileIndex> {
		return new Set<TileIndex>(
			// zasobuje len 2 furnaces
			Array.from(super.suppliesTileIndexes).slice(0, 2),
		);
	}

	public get consumption(): Map<ResourceType, number> {
		const consumption = new Map<ResourceType, number>(super.consumption);
		let populationConsumption =
			(consumption.get(ResourceType.POPULATION_CONSUMPTION) as number) ||
			0;
		populationConsumption -= getUpgradeCurrentReplaceValueById(
			UpgradeIds.hoisting_winch,
		);
		consumption.set(
			ResourceType.POPULATION_CONSUMPTION,
			populationConsumption,
		);

		return consumption;
	}
}

export default AdvancedIronMineBuildingTileEntity;
